// DO NOT EDIT -- generated from Go package fs/services/amber/model

///////////
// Enums //
///////////

export enum DailyActivesFrequency {
	Daily = 1,
	Weekly = 7,
	Monthly = 30
}

export enum AlertType {
	Trendline = "trendline"
}

export enum NotificationMedium {
	Slack = "slack",
	Email = "email",
	InApp = "in-app"
}


///////////////
// Constants //
///////////////

export const DefaultMaxAlerts: number = 5e+01;
export const MaxAlertDescriptionLen: number = 2.5e+02;

/////////////
// Structs //
/////////////

// TrendlineSettings is the settings on a trendline alert.
export interface TrendlineSettings {
  Value: number;
  Above: boolean;
}

// DailyActivesThresholdSettings is the concrete settings type for trendline alerts
// on the Daily Actives searchie.
export interface DailyActivesThresholdSettings extends TrendlineSettings {
  NDayActive: DailyActivesFrequency;
}

// A SegmentKey is the sequence of names/IDs that identifies a Segment.
// At this point it is only used for parenting in the cases of alerts.
export interface SegmentKey {
  SeatName: string;
  SegmentId: string;
  SegmentName: string;
}

// A SearchieKey is the sequence of names/IDs that identifies a Searchie.
export interface SearchieKey extends SegmentKey {
  SearchieName: string;
}

// An AlertKey is the sequence of names/IDs that identifies an Alert.
export interface AlertKey extends SearchieKey {
  AlertId: string;
}

// An AlertNotificationKey is the sequence of identifiers that identify
// an AlertNotification entity.
export interface AlertNotificationKey extends AlertKey {
  AlertNotificationId: string;
}
